// extracted by mini-css-extract-plugin
export default {"btn":"SearchResultRow_btn__Q3azw","table-number-cell":"SearchResultRow_table-number-cell__8h7Mx","tr":"SearchResultRow_tr__bRqQY"};